/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        $('.toggle-button').click( function() {
              $(".nav-main").toggleClass("nav-active");
              $(".nav-main").toggle();
          } );

        $('.more-link-click').click( function() {
              $(".more-link-area").toggleClass("active");
          } );
        // $('header').affix({});

        
// window resize home section
$(window).resize(function() {
  var windowWidth = $(window).width();
  if(windowWidth > 767){
    $('.findheight').height(function(){
      $(this).css('height', 'auto');
      return $(this).parent().height();
    });
  }
});

$(window).trigger('resize');

$(window).resize(function() {
  var windowWidth = $(window).width();
  if(windowWidth > 767){
    $('.findminheight').height(function(){
      $(this).css('min-height', 'auto');
      return $(this).parent().height();
    });
  }
});

$(window).trigger('resize');


// window resize slide
$(window).resize(function() {
  var windowWidth = $(window).width();
    $('.findheight-slide').height(function(){
      $(this).css('height', 'auto');
      return $(this).parent().height();
    });
});

$(window).trigger('resize');
  

var root = $('img.main-logo').attr('src');

$(window).scroll(function() {

  var newroot = root.replace('bb_logo.png', 'bb_mob_logo.png');

  if ($(document).scrollTop() > 50) {
    $('header.banner').addClass('shrink');
    $('img.main-logo').attr('src', newroot);
  } else {
    $('header.banner').removeClass('shrink');
    $('img.main-logo').attr('src', root);
  }
});

$('#pageslider').flexslider({
      animation: "slide",
      directionNav: false
     });



 $('.blog-drop').click( function() {
              $(".blog-drop h3 img").toggleClass("rotate");
          });


        $('.team-hover-secton').click( function() {
            $('.team-hover-secton').removeClass('active');
            $(this).toggleClass("active");
            // $('#'+$(this).data('id')).toggle();
          });


//  $(document).find("div[id^='sublike-']").live('click', function(){
//     var num = this.id.split('-')[1];
//     $('#sublike-form-' + num).toggle();
// });



    $("#tabs").tabs({active: 0});

     smoothScroll.init();


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    'single': {
      init: function() {
        // JavaScript to be fired on a single page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    

    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page


          $('#sliderhome').flexslider({
                    animation: "slide",
                    directionNav: false
                   });

          $('#sliderytestimonials').flexslider({
                    animation: "slide",
                    directionNav: false
                   });


          $('#slidernews').flexslider({
                    animation: "slide",
                    directionNav: true,
                    minItems: 2,
                    maxItems: 2
                   });

          
 $('#latestnews').owlCarousel({
     loop:true,
    margin:50,
    nav:false,
    items:2,

    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:2
        }
    } 
    });

 


  $('.next').on('click',function(){
    var owl = $('#latestnews')
    owl.owlCarousel();
        owl.trigger('next.owl.carousel');
  });

  $('.prev').on('click',function(){
    var owl = $('#latestnews').owlCarousel();
        owl.trigger('prev.owl.carousel');
  });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
